import store from '@/store';
import auth from '@/common/auth/auth';
import _ from '@/common/helpers';
import checkbox from '@/components/grid/columns/predefined/checkbox';
import GridMergeCustomers from '@/modules/customers/components/merge/grid-merge-customers';

export default {
    store,
    version: 7,
    customFields: 'customers',
    batchActions: [
        {
            component: GridMergeCustomers,
            predicate: auth.mergeCustomers.isAllowed,
        },
    ],
    actionColumns: [
        checkbox,
    ],
    defaultColumns: [
        {
            header: 'Name',
            type: 'link',
            value: _.getIdentifier({concat: ['firstName', 'lastName']}),
            name: 'firstName',
            to: ({fields}) => ({
                name: 'customer-details',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['customer-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            sortable: true,
            sticky: true,
        },
        {
            name: 'email',
            sortable: true,
        },
        {
            header: 'Lifetime Revenue',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'lifetimeRevenue.currency',
            name: 'lifetimeRevenue.amount',
            sortable: true,
        },
        {
            header: 'Average Value',
            type: 'numeric',
            format: 'currency',
            approx: false,
            currency: 'averageValue.currency',
            name: 'averageValue.amount',
            sortable: true,
        },
        {
            header: 'Payments',
            name: 'paymentCount',
            type: 'numeric',
            sortable: true,
        },
        {
            header: 'Last Payment',
            name: 'lastPaymentTime',
            type: 'datetime',
            sortable: true,
        },
    ],
    otherColumns: [
        {
            name: 'id',
            type: 'link',
            to: ({fields}) => ({
                name: 'customer-details',
                params: {
                    id: fields.id,
                },
            }),
            predicate: auth.$pages['customer-details'].isAllowed,
            predicateOverride: {
                type: 'text',
            },
            sortable: true,
            style: {truncate: true},
        },
        {
            name: 'websiteId',
            type: 'text',
            sortable: true,
        },
        {
            name: 'tags',
            value: item => item.tags.reduce((acc, curr) => [...acc, curr.name], []),
        },
        {
            name: 'invoiceCount',
            type: 'numeric',
            sortable: true,
        },
        {
            name: 'createdTime',
            header: 'Creation Time',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'updatedTime',
            header: 'Last Update Time',
            type: 'datetime',
            sortable: true,
        },
        {
            name: 'leadSource.campaign',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.medium',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.source',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.term',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.content',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.affiliate',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.subAffiliate',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.salesAgent',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.amount',
            expand: 'leadSource',
        },
        {
            name: 'leadSource.path',
            expand: 'leadSource',
        },
    ],
};
